import React from 'react';
import Recurso from './components/Recurso';
import Card from '../Card';

const Recursos = ({ vestibular, equipesRecursos }) => {
    if (equipesRecursos.length === 0) {
        return <></>;
    }

    return (
        <Card title="Recursos">
            {
                equipesRecursos.situacao === 'aberto' ? <>
                    <div className="alert alert-info">
                        <small>
                            <strong>Atenção:</strong>
                            Está aberto o período de recursos para os candidatos que não tiveram suas avaliações aceitas pelas seguintes comissões.

                            <div>
                                <strong>Observação: </strong> o candidato que não tiver sido aprovado em mais de uma comissão, deverá abrir recurso em cada uma das comissões de forma independente através dos
                                botões abrir recurso no prazo estipulado no Edital.
                            </div>
                        </small>
                    </div>
                </> : ''
            }

            <div className="d-block w-100 my-3" style={{ columnGap: '5px' }}>
                {equipesRecursos?.equipes.map(equipe => {
                    return (
                        <Recurso vestibular={vestibular} situacao={equipesRecursos.situacao} equipeId={equipe.id_equipe_avaliacao} key={equipe.id_equipe_avaliacao} initial={equipe}>
                            {equipe.nm_equipe}
                        </Recurso>
                    );
                })}
            </div>
        </Card>
    );
};

export default Recursos;
